import { Component, inject, input } from '@angular/core';
import { AufgabenTyp } from '@schir-int-client/aufgabe-shared';
import { CreateAufgabeFormService } from '../../../create-aufgabe-dialog/create-aufgabe.formservice';

type AllowedAufgabenTyp = AufgabenTyp.LFPR_WEGLEGEN | AufgabenTyp.LFPR_SAMMLUNG;

@Component({
	selector: 'schir-int-client-aufgabe-lfpr-weglegen-editor',
	templateUrl: './aufgabe-lfpr-weglegen-editor.component.html',
	styleUrls: ['./aufgabe-lfpr-weglegen-editor.component.scss'],
	standalone: false,
})
export class AufgabeLfprWeglegenEditorComponent {
	private readonly formService = inject(CreateAufgabeFormService);

	readonly aufgabenTyp = input.required<AllowedAufgabenTyp>();

	get formGroup() {
		return this.formService.form.controls[this.aufgabenTyp()];
	}

	get bodyControls() {
		return this.formGroup.controls.body.controls;
	}
}
